import HotelsWithCheapestPrice from './HotelsWithCheapestPrice';

export default HotelsWithCheapestPrice;
